// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"d3e8a652","211":"47aa83f8","344":"f374cf5d","634":"28802458","683":"af523585","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};